<mat-card appearance="outlined">
  <mat-card-content>
    <div class="flex-col">
      @if (loadingIndicator) {
        <mat-progress-bar mode="query"></mat-progress-bar>
      }

      <mat-accordion displayMode="flat" class="mat-mdc-table">
        <section class="mat-elevation-z2 mat-mdc-header-row">
          <span class="mat-mdc-header-cell">Namn</span>
          <span class="mat-mdc-header-cell">Uppfyllelsegrad (%)</span>
          <span class="mat-mdc-header-cell">Kvarstående</span>
          <span class="mat-mdc-header-cell">Bedömda</span>
          <span class="mat-mdc-header-cell">&nbsp;</span>
        </section>
        @for (standardGroup of standardGroups$ | async; track standardGroup) {
          <mat-expansion-panel [expanded]="standardGroup.reportStandardGroupId == selectedReportStandardGroupId">
            <mat-expansion-panel-header class="mat-mdc-row">
              <span class="mat-mdc-cell">{{ standardGroup.name }}</span>
              <span class="mat-mdc-cell">{{ standardGroup.fulfilledPercentage }}</span>
              <span class="mat-mdc-cell">{{ standardGroup.unassignedStandardCount }}</span>
              <span class="mat-mdc-cell">{{ standardGroup.assignedStandardCount }}</span>
              <span class="mat-mdc-cell"><button mat-button color="primary" (click)="showDetails($event, standardGroup)">Kommentarer</button></span>
            </mat-expansion-panel-header>
            <div>
              <app-report-standard-list [reportStandardGroupId]="standardGroup.reportStandardGroupId" [reportStandards]="standardGroup.reportStandards" [reportIsDirty]="reportIsDirty" [dirtyMessage]="dirtyMessage"  [hasPermissionToChange$]="hasPermissionToChange$" (refreshRequest)="refreshRequested($event)"></app-report-standard-list>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </mat-card-content>
</mat-card>
